import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ProductsMenu from './Menu'
import ProductsMobileMenu from './MenuMobile'
import ScreenSizeContext from 'utils/contexts/ScreenSize/context'
import ProductsAlert from './Alert'
import useShowPasses from 'hooks/useShowPasses'
import { useSelector } from 'react-redux'
import ProductsModule from 'modules/products'

const ProductsLayout = ({
    children,
    showMenu,
}) => {
    const { isLgUp } = useContext(ScreenSizeContext)
    const productsLoading = useSelector(ProductsModule.selectors.getProductsLoading)
    const showPasses = useShowPasses()
    return (
        <>
            {showMenu && (isLgUp ? <ProductsMenu showPasses={showPasses} productsLoading={productsLoading} /> : <ProductsMobileMenu showPasses={showPasses} productsLoading={productsLoading} />)}
            <ProductsAlert />
            {children}
        </>
    )
}

ProductsLayout.propTypes = {
    children: PropTypes.node,
    showMenu: PropTypes.bool,
}

export default ProductsLayout
